/**
 * Normalize DRF list responses: plain array, or { key: [...] }, or paginated { key: { results, count } }.
 */

export function unwrapListEnvelope(data, key) {
  if (Array.isArray(data)) return data;
  const block = data?.[key];
  if (!block) return [];
  if (Array.isArray(block)) return block;
  if (Array.isArray(block.results)) return block.results;
  return [];
}

/** Total item count for dashboard-style stats (uses `count` when paginated). */
export function countPagedItems(data, key) {
  const block = data?.[key];
  if (!block) return 0;
  if (Array.isArray(block)) return block.length;
  if (typeof block.count === 'number') return block.count;
  if (Array.isArray(block.results)) return block.results.length;
  return 0;
}
